import React, { useContext } from "react";
import HeaderNav from "../components/HeaderNav";
import Hero from "../components/Hero";
import Footer from "../components/Footer";
import { BodyText, NormalHeading } from "../global/component";
import AuthContext from "../global/auth-context";
import { useNavigate } from "react-router";
import { Analytics } from "@vercel/analytics/react";

const Profile = () => {
  let { userData, user } = useContext(AuthContext);
  let navigate = useNavigate();

  if (!user) {
    return navigate("/login");
  }
  return (
    <div className="flex flex-col justify-between h-full">
      <div>
        <Analytics />
        <HeaderNav page={"profile"} />
        <Hero>
          <div className="flex flex-col md:px-32 py-5 gap-7 h-full justify-center px-5">
            <div className="flex flex-wrap gap-3 md:gap-7">
              <p className=" text-white font-bold md:text-5xl text-3xl md:w-full">
                View Your
              </p>
              <span className=" text-yellow-400 font-bold md:text-5xl text-3xl">
                Profile Details
              </span>
              <span className=" text-white font-bold md:text-5xl text-3xl">
                Here
              </span>
            </div>
            <p className=" text-white font-normal text-xl md:text-2xl w-2/3">
              Users can get to convert their booking codes from one bookie to
              another.
            </p>
            <p className=" text-white font-normal text-xl md:text-2xl w-2/3">
              <span className=" text-yellow-500 font-normal text-xl">
                Note:{" "}
              </span>{" "}
              each successful conversion cost 1 unit.
            </p>
          </div>
        </Hero>
        <div className="flex py-10 px-5 bg-myLightGreen sm:px-14 lg:px-20 gap-5 flex-col">
          <div className="w-full gap-1 flex flex-col">
            <NormalHeading Text={"Username"} />
            <div className="px-2 bg-white w-full flex py-2 border-2 border-myNormalGreen">
              <BodyText Text={userData.userName} />
            </div>
          </div>
          <div className="w-full gap-1 flex flex-col">
            <NormalHeading Text={"Email"} />
            <div className="px-2 bg-white w-full flex py-2 border-2 border-myNormalGreen">
              <BodyText Text={userData.email} />
            </div>
          </div>
          <div className="w-full gap-1 flex flex-col">
            <NormalHeading Text={"Phone "} />
            <div className="px-2 bg-white w-full flex py-2 border-2 border-myNormalGreen">
              <BodyText Text={userData.phone} />
            </div>
          </div>
          <div className="w-full gap-1 flex flex-col">
            <NormalHeading Text={"Plan "} />
            <div className="px-2 justify-between bg-white w-full flex py-2 border-2 border-myNormalGreen">
              <BodyText Text={userData.planName} />
              {/* {userData.planName == "free" && (
                <a href="/premium" className="text-myNormalGreen">
                  upgrade
                </a>
              )} */}
            </div>
          </div>
          <div className="w-full gap-1 flex flex-col">
            <NormalHeading Text={"Country "} />
            <div className="px-2 bg-white w-full flex py-2 border-2 border-myNormalGreen items-center gap-3">
              <img
                src={userData.countryFlag}
                style={{ height: 15, width: 15 }}
              />
              <BodyText
                Text={userData.country && userData.country.toUpperCase()}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Profile;
